export default {
    getKey(enumInstance, value, defaultVal) {
        for(var key in enumInstance) {
            if(enumInstance[key] === value) {
                return key;
            }
        }

        return defaultVal === undefined? null: defaultVal;
    }
}


// WEBPACK FOOTER //
// ./src/js/enum.js